import React from 'react'
import { Button, Progress } from '@mantine/core'
import { Link } from 'react-router-dom'
import { IconArrowRight } from '@tabler/icons-react'

export default function CourseCard({ id, image, title, days, hours, percentage, ...others }) {
   return (
      <div key={id} className="activeCardCourse-column-div" {...others} >
         <div className="activeCardCourse-father-div">
            <div className="activeCardCourse-content-div">
               <img className="activeCardCourse-img" src={image} alt={title} />
               <div className="activeCardCourse-info-div">
                  <p className="activeCardCourse-course-title">{title}</p>
                  <p className="activeCardCourse-course-description">{days} <span>{hours}</span></p>
               </div>
            </div>
         </div>

         <div className="activeCardCourse-progressBar-div">
            <p className="activeCardCourse-percentage-complete">
               Curso completado en un {percentage}%
            </p>
            <Progress value={percentage} color="#DF3576" />
         </div>
         <Button
            rightSection={<IconArrowRight/>}
            variant='light'
            component={Link}
            color='var(--color-tertiary)'
            to={`/campus/curso/${id}`}
         >Ver más</Button>
      </div>
   )
}
